// @ngInject
Models.TimelineSectionsCollection = function TimelineSectionsCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'TimelineSectionsCollection';
                this._collection.__childsType = 'TimelineSectionModel';
                this._collection.shouldMergeOnLoad = false;
                return this._collection;
            }
        }
    );
};